/* projects/shared/src/lib/components/job-info/job-info.component.scss */
.mat-column-dataHoraFim,
.mat-column-dataHoraInicio {
  flex: 0 0 12em;
}
.mat-column-expand {
  flex: 0 0 5em;
}
mat-row.motivo-row {
  display: none !important;
  height: 0px !important;
  padding: 0 !important;
  border-bottom-width: 0 !important;
}
.detail-row td {
  border-bottom-width: 0;
}
.motivo-row td {
  border-bottom-width: 0;
}
/*# sourceMappingURL=job-info.component.css.map */
